module.exports = __webpack_public_path__ + "static/media/IMG_2081.b1e13f91.JPG";